import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

/**
 * Las mutaciones abstractas derivan el nombre de la clave del ÚLTIMO segmento del
 * resource: 'exports/downloads' escribe downloadsList / downloadsCount /
 * downloadsDetail. Hay que predeclararlas: Vue 2 no hace reactiva una clave raíz
 * asignada por primera vez desde una mutación, y SET_DETAIL tiene la guarda
 * `if (state[detailName])`.
 *
 * Por lo mismo NO usar 'exports/purchases' con commitInstance, porque el último
 * segmento sería 'purchases' y colisiona con el listado real de compras.
 */
const state = {
  ...stateAbstract,
  downloadsDetail: {},
  downloadsCount: null,
  downloadsList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
